module.exports = __webpack_public_path__ + "img/PayrollInfo.bf8603b9.svg";